import { Tonality } from '@dsny/dsny-component-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { rolesData } from 'src/consts/RolesData';
import {
  ComboboxInputStyles,
  ComboboxOptionWrapper,
  ComboboxPopoverStyles,
  ComboboxStyles,
  ComboboxWrapper,
  InlineMessage,
  InputLabelStyles,
  ItemWrapper,
} from './SignupFields.styles';

export type RoleData = {
  index: number | undefined;
  id: string;
  description: string;
};

interface Props {
  onSelect: (item?: RoleData) => void;
  ref?: null;
  error: boolean;
}

const SignupRole: React.FC<Props> = ({ error, onSelect }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string>('');

  const openCombobox = () => {
    setOpen(true);
  };

  const closeCombobox = () => {
    setOpen(false);
  };

  // Handling role selection
  const onChange = (option: string) => {
    setValue(option);
    onSelect(rolesData.find((item) => item.description === option));
  };

  return (
    <>
      {/* Role */}
      <ComboboxWrapper>
        <Tonality.Combobox
          label={t('SIGNUP_ROLE')}
          isOpen={open}
          onClick={openCombobox}
          onClose={closeCombobox}
          onChange={onChange}
          value={value}
          setting="mtr"
          style={{ ...ComboboxStyles }}
        >
          <Tonality.ComboboxInput
            placeholder={t('SIGNUP_SELECT_PLACEHOLDER')}
            required
            hasError={error}
            style={{ ...ComboboxInputStyles }}
            inputLabelStyles={{ ...InputLabelStyles }}
          />
          <Tonality.ComboboxPopover style={{ ...ComboboxPopoverStyles }}>
            <Tonality.ComboboxList
              style={{ paddingTop: '16px', paddingBottom: '16px' }}
            >
              {rolesData?.map((role) => (
                <ComboboxOptionWrapper
                  key={role.id}
                  value={role.description}
                  isSelected={role.description === value}
                  style={{ paddingLeft: '16px' }}
                >
                  <ItemWrapper>{role.description}</ItemWrapper>
                </ComboboxOptionWrapper>
              ))}
            </Tonality.ComboboxList>
          </Tonality.ComboboxPopover>

          {/* If not selected apply inline message  */}
          {error && (
            <InlineMessage $inlineMessage>
              {t('SIGNUP_ROLE_ERROR_MESSAGE')}
            </InlineMessage>
          )}
        </Tonality.Combobox>
      </ComboboxWrapper>
    </>
  );
};

export default SignupRole;
